import {
  DocumentTextIcon,
  GlobeAltIcon,
  SquaresPlusIcon,
  ChevronLeftIcon,
  ChatBubbleLeftIcon,
  ListBulletIcon,
  TableCellsIcon,
  EllipsisHorizontalCircleIcon,
  IdentificationIcon
} from "@heroicons/react/24/outline";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { baseColor } from "../..";
import systemParametersQuery from "../../firestore/SystemParameters.query";
import companiesQuery from "../../firestore/Companies.query";
import { nowDate } from "../../model/OptionContract";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { alertOpen, AlertValue } from "../../features/alert.slice";
import { ConstMessage, SessionKey } from "../../config/const";
import companiesApi from "../../api/Companies.api"

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

const style = {
  color: {
    blue: `bg-blue-50 border-blue-600 text-blue-600`,
    green: `bg-green-50 border-green-600 text-green-600`,
    red: `bg-red-50 border-red-600 text-red-600`,
    yellow: `bg-yellow-50 border-yellow-600 text-yellow-600`,
    indigo: `bg-indigo-50 border-indigo-600 text-indigo-600`,
  },
};

export const CompaniesSidebar = () => {

  const [userIdCardFlg, setUserIdCardFlg] = useState(false);

  const location = useLocation();
  // URLパラメータからtenantId取得
  const { tenantId } = useParams<{ tenantId: string }>();
  const dispatch = useDispatch();

  const selectStyles = (to: string) => {
    const pathname = location.pathname;
    if (pathname === to) {
      return style.color[baseColor];
    } else {
      return "border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900";
    }
  };

  useEffect(() => {
    const f = async () => {
      try {

        //sessionStorageから取得した選択されているテナントIDが、
        //引数として与えられているtenantIdと一致するか
        if(sessionStorage.getItem(SessionKey.SELECTED_TENANT_ID) ===  tenantId ){
          setUserIdCardFlg(sessionStorage.getItem(SessionKey.USER_ID_CARD_AUTH) === "true");
        }else{
          // 直接URLを入れて表示した場合
          sessionStorage.setItem(SessionKey.SELECTED_TENANT_ID, String(tenantId));
          // 利用者IDカードの権限の有無を取得
          const userIdCardAuth = await companiesApi.requestIdCardAuth(tenantId!);
          sessionStorage.setItem(SessionKey.USER_ID_CARD_AUTH, String(userIdCardAuth.success ? userIdCardAuth.data : false));
          setUserIdCardFlg(userIdCardAuth.success ? userIdCardAuth.data : false);
          if(!userIdCardAuth.success){
            throw new Error();
          }
        }
      } catch (err: any) {
        console.error(err);
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_GET_DATA, "danger")));
      }
    };
    f();
  },[]);

  const navigation = [
    { name: "一覧へ", href: "/companies", icon: ChevronLeftIcon, current: true},
    { name: "団体情報編集", href: `/companies/${tenantId}/info`, icon: DocumentTextIcon },
    { name: "お知らせ", href: `/companies/${tenantId}/message`, icon: ChatBubbleLeftIcon },
    { name: "トップ画面設定", href: `/companies/${tenantId}/menuSettings`, icon: ListBulletIcon, current: true },
    { name: "連携ボタンメニュー設定", href: `/companies/${tenantId}/linkMenus`, icon: TableCellsIcon, current: false },
    { name: "ミーティングURL設定", href: `/companies/${tenantId}/onlineUrlSetting`, icon: GlobeAltIcon },
    { name: "返信ボタン設定", href: `/companies/${tenantId}/replyButtons`, icon: SquaresPlusIcon },
    { name: "オプション契約設定", href: `/companies/${tenantId}/optionContractSetting`, icon: EllipsisHorizontalCircleIcon },
    { name: "利用者IDカード出力", href: `/companies/${tenantId}/userIdCardCreating`, icon: IdentificationIcon, displayFlg: userIdCardFlg },
  ];

  return (
    <div className="flex flex-grow bg-[#fcfafd] min-h-[calc(100vh-64px)]">
      <div className="flex flex-col overflow-y-auto sticky top-0 py-3 min-w-fit border-r-2">
        <nav className="flex-1 space-y-1">
          {navigation.map((item) => (
            <>
              {item.displayFlg == undefined || item.displayFlg == true ? 
                <>
                  <a
                    key={item.name}
                    href={item.href}
                    className={classNames(
                      selectStyles(item.href),
                      "group flex items-center px-3 py-2 text-sm font-medium border-l-4"
                    )}
                  >
                    <item.icon
                      className={classNames(
                        item.current
                          ? "text-gray-500"
                          : "text-gray-400 group-hover:text-gray-500",
                        "mr-3 flex-shrink-0 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    {item.name}
                  </a>
                </> : <></>
              } 
            </>
          ))}
        </nav>
      </div>
      <div className={"w-full"}>
        <Outlet />
      </div>
    </div>
  );
};
